<div class="container" #container>
  <div class="navigate-chips">
    <div matRipple class="order-chips print-thesis active">
      <h3>سفارش پرینت</h3>
    </div>
  </div>
  <div #printOrderContainer class="print-order-container" @fadeInOut>
    <mat-card class="print-order-card">
      <section #overlayOrigin *ngIf="tarefeOptions && !(isHandset$ | async)" id="tarefe" [@tarefeToggle]="
          tarefeToggle && !(isHandset$ | async) ? 'open' : 'close'
        " [class.displayOver]="(isHandset$ | async)! && tarefeToggle" class="tarefe-box"
        (click)="$event.stopPropagation()">
        <app-tarefe [options]="tarefeOptions" [(toggle)]="tarefeToggle" />
      </section>
      <div *ngIf="this.bindings.length <= 0 && this._typings.length <= 0" id="overlay" fxLayout="row"
        fxLayoutAlign="center center">
        <div class="spinner">
          <mat-spinner />
        </div>
      </div>

      <mat-card-title class="title">
        <div style="background-color: transparent" fxLayout="row" fxLayoutAlign="space-between center"
          class="button-container">
          <public-file-upload (status)="onStatus($event)" (file)="saveFileUploadReport($event)" name="main"
            class="upload-main" />

          <span class="print-order-status" style="color: var(--warn)">{{
            statusText || " "
            }}</span>
          <div (click)="startHelp()" class="help" fxLayout="row" fxLayoutAlign="space-between center">
            <span> راهنما </span>
            <div class="help-icon" fxLayout="center" fxLayoutAlign="center">
              ؟
            </div>
          </div>
        </div>
      </mat-card-title>
      <!-- [class.disabled]="!this.fileUploadReport" -->

      <mat-card-content>
        <form [formGroup]="orderFormGroup">
          <div class="block" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div class="paper-size" [fxFlex]="defaultInputBlockSize" fxFlex.lt-md="30" style="min-height: 240px"
              id="printSize">
              <mat-form-field style="width: 100%" appearance="outline">
                <mat-label> اندازه کاغذ </mat-label>

                <mat-select id="printSize" formControlName="printSize">
                  <mat-option *ngFor="let typing of _typings" [value]="typing.name">
                    {{ typing.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <mat-form-field [fxFlex]="defaultInputBlockSize" fxFlex.lt-md="33" appearance="fill"
              matTooltip="چاپ رنگی و یا سیاه و سفید  را نسبت به نیاز خود انتخاب کنید" appearance="outline"
              id="printColor">
              <mat-label> نوع چاپ </mat-label>

              <mat-select placeholder="نوع چاپ" formControlName="pageColor"
                (selectionChange)="navigateTo($event.value)">
                <mat-option [value]="printColorsConst.BLACK_WHITE">
                  سیاه و سفید
                </mat-option>

                <mat-option [value]="printColorsConst.COLORFUL">
                  رنگی
                </mat-option>

                <mat-option [value]="printColorsConst.HALF_COLORFUL">
                  نیمه رنگی
                </mat-option>

                <mat-option [value]="printColorsConst.MIXED">
                  ترکیبی
                </mat-option>
              </mat-select>
            </mat-form-field>

            <app-print-btn-toggle [default]="twoSided?.value ? 'twoSide' : 'oneSide'" (change)="setTwoSided($event)"
              class="print-btn-toggle" [fxFlex]="defaultInputBlockSize" fxFlex.lt-md="33"
              id="printBtnToggle"></app-print-btn-toggle>

            <div class="every-page-price" *ngIf="this.printSize?.value != 'mixed'">
              <span class="price-span" *ngIf="(getPriceofSelectedOnePage()?.length || 0) >= 1">
                قیمت هر برگ
                {{ getPriceofSelectedOnePage() | number: '1.' }}
                تومان
              </span>
            </div>
          </div>

          <div class="block" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <div class="total-range" fxFlex="65" fxFlex.xs="100" fxFlex.md="100" fxFlex.sm="100" fxLayout="row"
              fxLayoutAlign="center stretch" id="pageRange">
              <mat-form-field fxFlex="50" class="print-range-form" appearance="outline" fillable="false"
                (click)="printAllInputToggle()">
                <mat-label>تعداد صفحات</mat-label>
                <input matInput type="number" inputmode="numeric" formControlName="customPageNo"
                  (click)="printAllInputToggle()" (keyup)="printAllInputToggle()"
                  [class.disabled-with-events]="printAllToggleController" />
                <span class="validation-span"
                  *ngIf=" this.orderFormGroup.get('customPageNo')?.getRawValue() && !customPageNoVlidation">
                  تعداد صفحات می‌تواند بین 10 تا
                  {{this.pageNo?.value}}
                  باشد
                </span>
              </mat-form-field>


              <div class="print-all like-mat-form-field" [ngClass]="{ 'disabled-field': beforeUpload }" fxFlex="50"
                fxLayout="row" fxLayoutAlign="space-between center" (click)="printAllCheckboxToggle()"
                [class.disabled-with-events]="!printAllToggleController">
                <span class="title">
                  همه صفحات
                  <span *ngIf="(pageNo?.value || 0) > 0">({{ pageNo?.value || 0 }})</span>
                </span>

                <mat-checkbox #printAllCheckbox color="primary" formControlName="printAll"
                  class="all-page-print-checkbox" />
              </div>
            </div>

            <div class="print-copies-num" [fxFlex]="defaultInputBlockSize" fxFlex.md="100" fxFlex.lt-sm="48">
              <mat-form-field id="copiesNumber" style="width: 100%" appearance="outline">
                <mat-label>تعداد نسخه</mat-label>
                <input #printCopiesNo matInput type="number" formControlName="copies" min="1" />
                <div class="arrows" matSuffix fxLayout="column">
                  <jam-icon matRipple (click)="
                      copies?.setValue((+printCopiesNo.value + 1).toString())
                    " color="warn" name="plus" />
                  <jam-icon (click)="
                      copies?.setValue((+printCopiesNo.value - 1).toString())
                    " matRipple color="warn" name="minus" />
                </div>
              </mat-form-field>
            </div>
          </div>

          <div class="block" fxLayout="row wrap" fxLayoutAlign="space-between center">
            <mat-form-field class="case-type" style="cursor: pointer" [fxFlex]="defaultInputBlockSize" fxFlex.lt-md="30"
              fxFlex.lt-md="48" appearance="outline" id="printCover">
              <mat-label>صحافی یا کاور</mat-label>
              <mat-select formControlName="caseType" #coverCaseType (selectionChange)="toggleBinding()">
                <mat-option value="plastic-cover"> کاور </mat-option>
                <mat-option value="binding"> صحافی </mat-option>
              </mat-select>
              <span class="price-binding-span" style="text-align: right;width: 100%;"
                *ngIf="orderFormGroup.value.caseType == 'plastic-cover' && !this.beforeUpload">
                قیمت کاور:
                {{ this.plasticCover?.price| number: '1.' }}
                تومان
              </span>
              <span class="price-binding-span" style="text-align: right;width: 100%;"
                *ngIf="orderFormGroup.value.caseType == 'binding' && !this.beforeUpload">
                 دستمزد صحافی:
                {{ this.bindSalaryFee.bindSalaryFee| number: '1.' }}
                تومان
              </span>
            </mat-form-field>

            <mat-form-field class="bindings-select" [fxFlex]="defaultInputBlockSize" fxFlex.md="30" fxFlex.lt-md="48"
              appearance="outline" id="printBinding">
              <mat-label>انتخاب صحافی</mat-label>
              <mat-select formControlName="binding" (selectionChange)="updateOrderPrice()">
                <mat-option *ngFor="let binding of filteredBindings()" [value]="binding.id">
                  <span *ngIf="binding.name.indexOf('منگنه') != -1">
                    {{ binding.name }}
                  </span>
                  <span *ngIf="binding.name.indexOf('منگنه') == -1">
                    فنر با {{ binding.name }}
                  </span>


                  <span></span>
                </mat-option>
              </mat-select>
              <span class="price-binding-span" style="text-align: right;width: 100%;"
                *ngIf="orderFormGroup.value.binding">
                قیمت صحافی:
                {{ getBindingSelectedPrice() | number: '1.' }}
                تومان


              </span>

            </mat-form-field>

            <div id="talcColorSelector" class="talc-color" [fxFlex]="defaultInputBlockSize" fxFlex.lt-md="100"
              fxFlex.md="30">
              <app-talc-color-selector style="width: 100%; display: block" [class.disabled]="!needsTalc()"
                [talcColors]="filteredTalcColors" [(selected)]="selectedTalcColor" [disabled]="!needsTalc()"
                (selectedChange)="onTalcColorChange($event)" />


            </div>
          </div>

          <div class="block print-block-selectors" fxLayout="row" fxLayoutAlign="space-between center"
            fxLayout.lt-md="column" [class.disabled]="pageColor?.value !== 'mixed' || beforeUpload">
            <print-mixed-range-select fxFlex="48" fxFlex.lt-md="100" style="width: 100%" [type]="halfColorfulType"
              [typings]="flatTypings!" [(blocks)]="printBlocks" (onChange)="updateOrderPrice()" title="صفحات نیمه رنگی"
              id="halfColorRangeSelect" [max]="fileUploadReport?.numpages"
              [disabled]="pageColor?.value !== 'mixed' || beforeUpload"></print-mixed-range-select>

            <print-mixed-range-select fxFlex="48" fxFlex.lt-md="100" style="width: 100%" [type]="colorfulType"
              [typings]="flatTypings!" [(blocks)]="printBlocks" (onChange)="updateOrderPrice()" title="صفحات تمام رنگی"
              id="fullColorRangeSelect" [max]="fileUploadReport?.numpages"
              [disabled]="pageColor?.value !== 'mixed' || beforeUpload"></print-mixed-range-select>
          </div>

          <div class="block" fxLayout="row" fxLayoutAlign="center center">
            <mat-form-field id="printOrderExtraInformation" class="textarea" fxFlex="100" appearance="outline">
              <mat-label>توضیحات بیشتر</mat-label>
              <textarea formControlName="moreDetails" matInput placeholder="توضیحات سفارش ..."
                style="resize: none"></textarea>
            </mat-form-field>
          </div>
          <div class="block mobile-submit-btn" fxLayout="row">
            <app-submit-btn [title]="!editMode ? 'افزودن به سبد خرید' : 'ویرایش سفارش'" id="submitBtn" fxFlex="49"
              fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" [anim-options]="submitAnimationOptions"
              (animationStart)="submit()" [anim-style]="mobileSubmitAnimationStyle" />
          </div>
        </form>
      </mat-card-content>
    </mat-card>
    <!-- <div class="spaceer" fxFlex="2"></div> -->
    <div id="copiesInput" fxLayout="column" fxLayoutAlign="center end" fxFlex="40" fxFlex.lt-md="100">
      <div class="submit" fxLayout="row" fxFlex="100" fxLayoutAlign="end stretch">
        <div id="totalPriceSection" class="total-price" fxFlex="40">
          <span class="title"> قیمت کل </span>
          <span class="price" fxLayout="column" fxLayoutAlign="center center">
            {{ price || "0" | irc : "T" | digitsEnToFa }}
          </span>
        </div>

        <app-submit-btn [class.disabled]="
            !this.orderFormGroup.valid || !this.fileUploadReport
          " [title]="!editMode ? 'افزودن به سبد خرید' : 'ویرایش سفارش'" [anim-options]="submitAnimationOptions"
          (animationStart)="submit()" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" id="submitBtn" fxFlex="60" />
      </div>
    </div>
  </div>
</div>

<app-dynamic-content *ngIf="printConfigs && printConfigs['why_ziraxi']" [config]="printConfigs" />